const LOCALES = {
    KO: "ko-KR",
    EN: "en-US",
    JA: "ja-JP",
    ZH_CN: "zh-CN",
    ZH_TW: "zh-TW",
    FR: "fr-FR",
    DE: "de-DE",
    ES: "es-ES",
    PT_BR: "pt-BR",
    TH: "th-TH",
    ID: "id-ID",
    HI: "hi-IN",
};
const SKILL_TYPE = {
    0: { "ko-KR": "패시브", "en-US": "passive" },
    1: { "ko-KR": "기본기", "en-US": "attack" },
    2: { "ko-KR": "특수기", "en-US": "special" },
    3: { "ko-KR": "궁극기", "en-US": "hyper" },
};
const JOURNEY_REWARD_TYPE = {
    RT_STAMINA: { "ko-KR": "스태미나", "en-US": "Stamina" },
    RT_CONDITION: { "ko-KR": "컨디션", "en-US": "Condition" },
    RT_JOURNEY_ITEM: { "ko-KR": "아이템", "en-US": "Item" },
    RT_STAT: { "ko-KR": "스탯", "en-US": "Stat" },
    RT_COIN: { "ko-KR": "오래된 주화", "en-US": "Old Coin" },
    RT_POTEN_POINT: { "ko-KR": "잠재력 포인트", "en-US": "Potential Point" },
    RT_SE_POTEN: { "ko-KR": "잠재력", "en-US": "Potential" },
    RT_STAT_POTEN: { "ko-KR": "스탯 인자", "en-US": "Stat Blessing" },
    RT_ARCANA_POINT: { "ko-KR": "인연 포인트", "en-US": "Bond Point" },
    RT_JOURNEY_BUFF: { "ko-KR": "여정 버프 획득", "en-US": "Buff" },
    RT_JOURNEY_BUFF_REMOVE_ALL: { "ko-KR": "모든 여정 버프 제거", "en-US": "All Journey Buff/Debuff Removal" },
    RT_JOURNEY_BUFF_REMOVE_POS: { "ko-KR": "이로운 여정 버프 제거", "en-US": "All Journey Buff Removal" },
    RT_JOURNEY_BUFF_REMOVE_NEG: { "ko-KR": "해로운 여정 버프 제거", "en-US": "All Journey DeBuff Removal" },

    SELECTABLE_CHARM: { "ko-KR": "선택 유물", "en-US": "Selectable Charm" },
};
const SAVIOR_ATTRIBUTE = {
    NUAT_SUN: { "ko-KR": "태양", "en-US": "Sun" },
    NUAT_MOON: { "ko-KR": "달", "en-US": "Moon" },
    NUAT_STAR: { "ko-KR": "별", "en-US": "Star" },
    NUAT_ORDER: { "ko-KR": "질서", "en-US": "Order" },
    NUAT_CHAOS: { "ko-KR": "혼돈", "en-US": "Chaos" },
};
const SAVIOR_CLASS = {
    NURT_STRIKER: { "ko-KR": "스트라이커", "en-US": "Striker" },
    NURT_ASSASSIN: { "ko-KR": "어쌔신", "en-US": "Assassin" },
    NURT_RANGER: { "ko-KR": "레인저", "en-US": "Ranger" },
    NURT_CASTER: { "ko-KR": "캐스터", "en-US": "Caster" },
    NURT_DEFENDER: { "ko-KR": "디펜더", "en-US": "Defender" },
    NURT_SUPPORTER: { "ko-KR": "서포터", "en-US": "Supporter" },
};
const SAVIOR_ATK_TYPE = {
    UAT_ELEMENT: { "ko-KR": "원소", "en-US": "Elemental" },
    UAT_SLASH: { "ko-KR": "참격", "en-US": "Slach" },
    UAT_IMPACT: { "ko-KR": "충격", "en-US": "Impact" },
    UAT_SPIRIT: { "ko-KR": "정신", "en-US": "Spirit" },
    UAT_VOID: { "ko-KR": "정신", "en-US": "Void" },
};
const NORMAL_STATUS_TYPE = {
    atk: { "ko-KR": "공격력", "en-US": "Attack" },
    hp: { "ko-KR": "생명력", "en-US": "Hp" },
    def: { "ko-KR": "방어력", "en-US": "Defence" },
    spd: { "ko-KR": "속도", "en-US": "Speed" },
    crit_rate: { "ko-KR": "치명타 확률", "en-US": "Crit Rate" },
    crit_dmg: { "ko-KR": "치명타 피해", "en-US": "Crit Dmg" },
    eff_rate: { "ko-KR": "효과 적중", "en-US": "Effect Hit" },
    eff_resist: { "ko-KR": "효과 저항", "en-US": "Effect Resist" },
    acc: { "ko-KR": "명중률", "en-US": "Accuracy" },
    def_eff_rate: { "ko-KR": "절대 적중", "en-US": "Definite Hit" },
    def_eff_resist: { "ko-KR": "절대 저항", "en-US": "Definite Resist" },
    super_armor: { "ko-KR": "강인도", "en-US": "Super Armor" },
};
const STATUS_TYPE = {
    NST_ATK: { "ko-KR": "공격력", "en-US": "Attack" },
    NST_HP: { "ko-KR": "생명력", "en-US": "Hp" },
    NST_DEF: { "ko-KR": "방어력", "en-US": "Defence" },
    NST_TURN_SPEED: { "ko-KR": "속도", "en-US": "Speed" },
    NST_RATE_CRITICAL: { "ko-KR": "치명타 확률", "en-US": "Crit Rate" },
    NST_RATE_CRITICAL_DAMAGE: { "ko-KR": "치명타 피해", "en-US": "Crit Dmg" },
    NST_RATE_EFFECT_HIT: { "ko-KR": "효과 적중", "en-US": "Effect Hit" },
    NST_RATE_EFFECT_EVADE: { "ko-KR": "효과 저항", "en-US": "Effect Resist" },
    NST_RATE_HIT: { "ko-KR": "명중률", "en-US": "Accuracy" },
};
const JOURNEY_STATUS_KEY_TYPE = {
    JST_POWER: { "ko-KR": "힘", "en-US": "Strength" },
    JST_HEALTH: { "ko-KR": "체력", "en-US": "Vitality" },
    JST_ENDURANCE: { "ko-KR": "인내", "en-US": "Endurance" },
    JST_FOCUS: { "ko-KR": "집중", "en-US": "Focus" },
    JST_PROTECT: { "ko-KR": "보호", "en-US": "Protection" },
};
const JOURNEY_STATUS_TYPE = {
    str: { "ko-KR": "힘", "en-US": "Strength" },
    hp: { "ko-KR": "체력", "en-US": "Vitality" },
    end: { "ko-KR": "인내", "en-US": "Endurance" },
    focus: { "ko-KR": "집중", "en-US": "Focus" },
    prot: { "ko-KR": "보호", "en-US": "Protection" },
};
const CHOICE_CONDITION_TYPE = {
    RR_STAT: { "ko-KR": "스탯", "en-US": "Stat" },
    RR_ITEM_CHECK: { "ko-KR": "아이템 보유", "en-US": "Have Item" },
    RR_ITEM_USE: { "ko-KR": "아이템 소모", "en-US": "Use Item" },
    RR_COIN_USE: { "ko-KR": "오래된 주화 소모", "en-US": "Use Old Coin" },
    RR_STAMINA_USE: { "ko-KR": "스태미나 소모", "en-US": "Use Stamina" },
    RR_PP_USE: { "ko-KR": "잠재력 포인트 소모", "en-US": "Use Potenial Point" },
};
const SKILL_TARGET_TYPE = {
    NSTT_MYSELF: { "ko-KR": "자기 자신", "en-US": "Self" },
    NSTT_ENEMY_ONE: { "ko-KR": "적 단일", "en-US": "1 Enemy" },
    NSTT_ENEMY_ALL: { "ko-KR": "적 전체", "en-US": "All Enemy" },
    NSTT_REACT_ENEMY_TARGET: { "ko-KR": "스킬을 사용한 적", "en-US": "Enemy that used the skill" },
    NSTT_ALLY_ONE: { "ko-KR": "아군 단일", "en-US": "1 Ally" },
    NSTT_ALLY_ALL: { "ko-KR": "아군 전체", "en-US": "All Ally" },
    NSETT_AUTO_ALLY_ONE_NOT_SELF: { "ko-KR": "최고 공격력 아군 단일", "en-US": "1 Ally who has highest attack" },
    NSTT_REACT_ALLY_TARGET: { "ko-KR": "반응형 아군 단일", "en-US": "Reactive 1 Ally" },
};
const JOURNEY_ITEM_TYPE = {
    NT_CHARM: { "ko-KR": "부적", "en-US": "Charm" },
    NT_COOK: { "ko-KR": "음식", "en-US": "Food" },
    NT_VALUABLES: { "ko-KR": "귀중품", "en-US": "Valuables" },
    NT_TRAINING_EXP_ITEM: { "ko-KR": "훈련 서적", "en-US": "Training Book" },
};
const CONSUME_TYPE = {
    UT_STAMINA: { "ko-KR": "스태미나", "en-US": "Stamina" },
    UT_CONDITION: { "ko-KR": "컨디션", "en-US": "Condition" },
    UT_PP: { "ko-KR": "포텐셜 포인트", "en-US": "Potential Point" },
    UT_JST_POWER: { "ko-KR": "힘", "en-US": "Strenght" },
    UT_JST_HEALTH: { "ko-KR": "체력", "en-US": "Health" },
    UT_JST_ENDURANCE: { "ko-KR": "인내", "en-US": "Endurance" },
    UT_JST_FOCUS: { "ko-KR": "집중", "en-US": "Focus" },
    UT_JST_PROTECT: { "ko-KR": "보호", "en-US": "Protection" },
    UT_SE_POTEN: { "ko-KR": "포텐셜", "en-US": "Potential" },
    UT_BUFF_ADD: { "ko-KR": "여정 버프 습득", "en-US": "Journey Buff Gain" },
    UT_BUFF_DELETE: { "ko-KR": "여정 버프 해제", "en-US": "Journey Buff Removal" },
    UT_BUFF_DELETE_NEGATIVE: { "ko-KR": "여정 디버프 해제", "en-US": "Journey Debuff Removal" },
    UT_TRAINING_EXP_POWER: { "ko-KR": "힘 훈련 경험치", "en-US": "Strength Training Exp" },
    UT_TRAINING_EXP_HEALTH: { "ko-KR": "체력 훈련 경험치", "en-US": "Health Training Exp" },
    UT_TRAINING_EXP_ENDURANCE: { "ko-KR": "인내 훈련 경험치", "en-US": "Endurance Training Exp" },
    UT_TRAINING_EXP_FOCUS: { "ko-KR": "집중 훈련 경험치", "en-US": "Focus Training Exp" },
    UT_TRAINING_EXP_PROTECT: { "ko-KR": "보호 훈련 경험치", "en-US": "Protection Training Exp" },
};
const ITEM_REGION = {
    0: { "ko-KR": "NOA", "en-US": "NOA" },
    1: { "ko-KR": "아가논", "en-US": "Aganon" },
    2: { "ko-KR": "플로라", "en-US": "Flora" },
    3: { "ko-KR": "칼라이드", "en-US": "Kalaid" },
};
const EQUIP_PART_TYPE = {
    0: { "ko-KR": "무기", "en-US": "Weapon" },
    1: { "ko-KR": "장갑", "en-US": "Gloves" },
    2: { "ko-KR": "갑옷", "en-US": "Armor" },
    3: { "ko-KR": "목걸이", "en-US": "Necklace" },
    4: { "ko-KR": "반지", "en-US": "Ring" },
    5: { "ko-KR": "신발", "en-US": "Boots" },
};
const SIMULATOR_BUFF_NAME = {
    isCounter: { "ko-KR": "카운터(+10%)", "en-US": "Counter(+10%)" },
    isBreak: { "ko-KR": "브레이크(+15%)", "en-US": "Break(+15%)" },
    isNova: { "ko-KR": "노바 버스트(+15%)", "en-US": "Nova(+15%)" },
    attrStack: { "ko-KR": "속성 스택(+1% / 1스택)", "en-US": "Attr(+1% / 1Stack)" },
    atkBuff: { "ko-KR": "공격력 버프(%)", "en-US": "Atk Up(%)" },
    hpBuff: { "ko-KR": "생명력 버프(%)", "en-US": "Hp Up(%)" },
    defBuff: { "ko-KR": "방어력 버프(%)", "en-US": "Def Up(%)" },
    spdBuff: { "ko-KR": "속도 버프(%)", "en-US": "Spd Up(%)" },
    defReduceBuff: { "ko-KR": "방어력 감소(%)", "en-US": "Def Down(%)" },
    damageBuff: { "ko-KR": "대미지 증가(%)", "en-US": "Dmg Up(%)" },
    critRateBuff: { "ko-KR": "치확 버프(%)", "en-US": "Crit Rate Up(%)" },
    critDmgBuff: { "ko-KR": "치피 버프(%)", "en-US": "Crit Dmg Up(%)" },
};
const MONTH_ENG = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "Novenber",
    12: "December",
};
const HURDLE_TITLE_ENG = {
    "기초 평가전": "Basic Trial",
    "토벌 평가전": "Hunt Trial",
    "원정 평가전": "Expedition Trial",
    "경쟁 평가전": "Competition Trial",
    합숙훈련: "Training Camp",
    "공허 평가전": "Void Trial",
    "최종 평가전": "Final Trial",
};
const OCCUR_TYPE_ENG = {
    고정: "Guaranteed",
    랜덤: "Random",
    // 확률: "Chance-based",
    확률: "Conditional",
};
const JOURNEY_EVENT_TYPE_ENG = {
    "인자 계승": "Blessing",
    여정: "Journey",
    구원자: "Savior",
    아르카나: "Arcana",
    평가전: "Trial",
    토벌: "Subjugation",
};
const SCHEDULE_CONTENT_ENG = {
    "인자 계승": "Blessing",
    "동료 합류 & 인자 계승": "Companion Join & Blessing",
    "구원자 이벤트(버프/디버프)": "Savior Event(Buff/Debuff)",
    "구원자 이벤트": "Savior Event",
    "구원자 이벤트(스태미나)": "Savior Event(Stamina)",
    "아르카나 이벤트": "Arcana Event",
    "미편성 아르카나 이벤트": "Unassigned Arcana Event",
    "(어려움) 훈련의 방향성": "(Hard) Direction of Training",
    "(어려움) 고대 구원자의 유물": "(Hard) Relic of an Ancient Savior",
    "(쉬움,보통) 약탈자 토벌 의뢰": "(Easy,Normal) Raider Hunt Quest",
    "(쉬움,보통) 슬라임 토벌 의뢰": "(Easy,Normal) Slime Hunt Quest",
    "(어려움) 슬라임 토벌 의뢰": "(Hard) Slime Hunt Quest",
    "(쉬움,보통) 탈영병 토벌 의뢰": "(Easy,Normal) Deserter Hunt Quest",
    "(어려움) 남작 토벌 의뢰": "(Hard) Baron Hunt Quest",
    "(어려움) 인형 토벌 의뢰": "(Hard) Doll Hunt Quest",
    "기초 평가전 승리": "Basic Trial Victory",
    "원정 평가전 승리": "Expedition Trial Victory",
    "공허 평가전 승리": "Void Trial Victory",
    "최종 평가전 승리": "Final Trial Victory",
    날씨: "Weather",
    "별빛의 인도": "Starlight Guidance",
};
const REGION_ENG = {
    NOA: "NOA",
    아가논: "AGANON",
    플로라: "FLORA",
    칼라이드: "KALAID",
};

const LOCALIZED_DIFF = {
    쉬움: {
        "en-US": "Easy",
        "ja-JP": "イージー",
        "zh-TW": "簡單",
        "zh-CN": "简单",
    },
    보통: {
        "en-US": "Normal",
        "ja-JP": "ノーマル",
        "zh-TW": "普通",
        "zh-CN": "普通",
    },
    어려움: {
        "en-US": "Hard",
        "ja-JP": "ハード",
        "zh-TW": "困難",
        "zh-CN": "困难",
    },
};

Object.freeze(LOCALES);
Object.freeze(SKILL_TYPE);
Object.freeze(JOURNEY_REWARD_TYPE);
Object.freeze(SAVIOR_ATTRIBUTE);
Object.freeze(SAVIOR_CLASS);
Object.freeze(SAVIOR_ATK_TYPE);
Object.freeze(NORMAL_STATUS_TYPE);
Object.freeze(STATUS_TYPE);
Object.freeze(JOURNEY_STATUS_KEY_TYPE);
Object.freeze(JOURNEY_STATUS_TYPE);
Object.freeze(CHOICE_CONDITION_TYPE);
Object.freeze(SKILL_TARGET_TYPE);
Object.freeze(JOURNEY_ITEM_TYPE);
Object.freeze(CONSUME_TYPE);
Object.freeze(ITEM_REGION);
Object.freeze(EQUIP_PART_TYPE);
Object.freeze(SIMULATOR_BUFF_NAME);
Object.freeze(MONTH_ENG);
Object.freeze(HURDLE_TITLE_ENG);
Object.freeze(OCCUR_TYPE_ENG);
Object.freeze(JOURNEY_EVENT_TYPE_ENG);
Object.freeze(SCHEDULE_CONTENT_ENG);
Object.freeze(REGION_ENG);
Object.freeze(LOCALIZED_DIFF);

module.exports = {
    LOCALES,
    SKILL_TYPE,
    JOURNEY_REWARD_TYPE,
    SAVIOR_ATTRIBUTE,
    SAVIOR_CLASS,
    SAVIOR_ATK_TYPE,
    NORMAL_STATUS_TYPE,
    STATUS_TYPE,
    JOURNEY_STATUS_KEY_TYPE,
    JOURNEY_STATUS_TYPE,
    CHOICE_CONDITION_TYPE,
    SKILL_TARGET_TYPE,
    JOURNEY_ITEM_TYPE,
    CONSUME_TYPE,
    ITEM_REGION,
    EQUIP_PART_TYPE,
    SIMULATOR_BUFF_NAME,
    MONTH_ENG,
    HURDLE_TITLE_ENG,
    OCCUR_TYPE_ENG,
    JOURNEY_EVENT_TYPE_ENG,
    SCHEDULE_CONTENT_ENG,
    REGION_ENG,
    LOCALIZED_DIFF,
};
